import { motion } from "framer-motion";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { WA_GENERAL } from "../lib/site";

export const FloatingWhatsApp = () => (
  <motion.a
    href={WA_GENERAL} target="_blank" rel="noopener noreferrer" aria-label="Chat on WhatsApp"
    initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 16 }}
    whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.92 }}
    className="group fixed bottom-5 right-5 z-50 flex items-center"
    data-testid="floating-whatsapp-btn"
  >
    <span className="mr-3 hidden rounded-full bg-ink px-4 py-2 text-sm font-bold text-white opacity-0 translate-x-2 transition-[opacity,transform] duration-300 group-hover:opacity-100 group-hover:translate-x-0 sm:block">
      Chat with us
    </span>
    <span className="relative grid h-14 w-14 sm:h-16 sm:w-16 place-items-center rounded-full bg-[#25D366] text-white shadow-[0_15px_40px_-10px_rgba(37,211,102,0.7)]">
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <WhatsAppIcon className="relative h-7 w-7 sm:h-8 sm:w-8" />
    </span>
  </motion.a>
);
